import { IPermissions } from '.';
import { httpService } from '../..';
import { IApiExecuteRespone } from '../apiInterfaces';
import { ApiUrls } from '../ApiUrls';
import { executeApiRequest } from '../asyncUtils';

export async function FetchPermissions(sid?: string): Promise<IApiExecuteRespone<IPermissions>> {
  return executeApiRequest(() => httpService.get(ApiUrls.getPermissions(sid)));
}
